module.exports = __webpack_public_path__ + "img/backward-step.5105b116.svg";